import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./Dashboard";
import SidebarCom from "../../component/SidebarCom/SidebarCom";
import TopbarCom from "../../component/TopbarCom/TopbarCom";
import UserManagment from "../UserManage/UserManagment";
import VendorManagment from "../UserManage/VendorManagment";
import Category from "../CategoryManagment/Category";
import Ads from "../Ads_managment/Ads";

function MainDashboard() {
  return (
    <div className="flex min-h-screen bg-gray-100 overflow-y-hidden">
      <SidebarCom />
      <div className="flex-1 flex flex-col relative">
        <TopbarCom />
        <div className="p-6 h-[calc(100vh-60px)] overflow-y-auto">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/users" element={<UserManagment />} />
            <Route path="/vendor" element={<VendorManagment />} />
            <Route path="/category" element={<Category />} />
            <Route path="/ads" element={<Ads />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default MainDashboard;
